import { render, staticRenderFns } from "./BaseTextDateTime.vue?vue&type=template&id=104f24cb&"
import script from "./BaseTextDateTime.vue?vue&type=script&lang=ts&"
export * from "./BaseTextDateTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports